module.exports = __webpack_public_path__ + "img/transferwise.23814197.svg";